// @flow
import type { IConstraintModel, FiletypeConstraintsType } from "../../types";

/**
 */
class FileExtensionConstraint implements IConstraintModel {
  _filetypeConstraints: FiletypeConstraintsType;

  /**
   */
  constructor(filetypeConstraints: FiletypeConstraintsType) {
    this._filetypeConstraints = filetypeConstraints;
  }

  /**
   */
  get id(): string {
    return "Constraint.File.InvalidExtension";
  }

  /**
   */
  get extensions(): string {
    return this._filetypeConstraints
      .map((filetypeConstraint) => filetypeConstraint.extensions.join(", "))
      .join(", ");
  }

  /**
   */
  hasValidation(): boolean {
    return false;
  }

  /**
   */
  get defaultMessage(): string {
    return "Allowed extensions are: ${extensions}"; // NOSONAR
  }

  /**
   */
  get parameters(): { extensions: string } {
    return { extensions: this.extensions };
  }

  /**
   */
  validate(): boolean {
    return true;
  }

  /**
   */
  get isMandatoryConstraint(): boolean {
    return false;
  }
}

export default FileExtensionConstraint;
